import React, { useEffect, useLayoutEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Divider,
    Stack,
    AccordionDetails,
    Accordion,
    AccordionSummary,
    Grid,
    Input,
    Rating,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { fetchOrdersByCustomerId } from "../../redux/orderSlice";
import { formatDateWithSlash } from "../../utilities/date-utility";
import { handlePayment } from "../../utilities/paymentUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { postReviews } from "../../utilities/reviewUtils";
import { OrderDetail } from "../../components/orderDetail/orderDetail";
import CommonAlert from "../../components/alert/CommonAlert";
import Header from "../../components/header/header";
import { GET_ORDER_BY_ID } from "../../redux/apis";
import Footer from "../../components/footer/footer";
import { axiosAuthInstance } from "../../redux/axiosInstance";

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

type Props = {};

const ViewOrder: React.FC<Props> = ({ }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { orderId } = location.state || { orderId: 3 };
    const [order, setOrder] = useState<any>();

    const statusColors = {
        green: ['CONFIRMED', 'DELIVERED'],
        red: ['CANCELLED', 'RETURNED', 'REFUNDED', 'FAILED'],
        orange: ['PENDING', 'PROCESSING'],
        blue: ['SHIPPED', 'OUT_FOR_DELIVERY'],
    };

    const getColor = (status: any) => {
        for (const [color, statuses] of Object.entries(statusColors)) {
            if (statuses.includes(status)) {
                return color;
            }
        }
        return 'gray';
    };

    useEffect(() => {
        if (!orderId || orderId == '') {
            navigate("/profile");
        }
        getOrderById();
    }, [])

    const getOrderById = async () => {
        try {
            const response = await axiosAuthInstance.get(`${GET_ORDER_BY_ID}${orderId}`);
            if (response) {
                setOrder(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <Header />

            {order && <Box sx={{ width: '100%' }}>
                <Box p={1} sx={{ width: '80%', margin: 'auto' }}>
                    <Grid item xs={12} md={12} mb={4} style={{ display: "flex", justifyContent: 'center' }}>
                        <Typography variant="h5">
                            <strong style={{ margin: "auto", marginLeft: '15px' }}>Order Details <Typography variant="subtitle2" color="primary" style={{ fontWeight: '700', margin: 'auto' }}>( #{order.orderNumber} )</Typography></strong>
                        </Typography>
                        {/* <Button sx={{ float: 'right' }}> Back to Orders</Button> */}
                    </Grid>
                    <Stack spacing={3}>
                        <Card key={order.id} variant="outlined">
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12} style={{ display: "flex", justifyContent: 'end' }}>
                                        <Typography variant="h6" color="primary">
                                            Order Status :
                                            <Box
                                                component="span"
                                                ml={2}
                                                sx={{
                                                    display: 'inline-block',
                                                    padding: '4px 8px',
                                                    borderRadius: '12px',
                                                    backgroundColor: getColor(order.orderStatus),
                                                    color: 'white',
                                                    fontSize: '0.75rem',
                                                    fontWeight: 700,
                                                    textTransform: 'capitalize',
                                                }}
                                            >
                                                {order.orderStatus}
                                            </Box>
                                            {order.paymentStatus && order.paymentStatus == 'PENDING' &&
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        display: 'inline-block',
                                                        padding: '4px 8px',
                                                        borderRadius: '12px',
                                                        marginLeft: '5px',
                                                        backgroundColor: '#c72a22',
                                                        color: 'white',
                                                        fontSize: '0.75rem',
                                                        fontWeight: 700,
                                                        textTransform: 'capitalize',
                                                    }}
                                                >
                                                    PAYMENT {order.paymentStatus}
                                                </Box>
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Divider sx={{ my: 2, bgcolor: "primary.main" }} />
                                <OrderDetail data={order} showButtons={true} />

                            </CardContent>
                        </Card>
                    </Stack>
                </Box>
            </Box>}

            <Footer />
        </>



    );
};

export default ViewOrder;
